import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-arrow-right-icon',
  templateUrl: 'arrow-right-icon.component.html'
})
export class ArrowRightIconComponent {
  constructor() {}
}
